import { defineMessages } from 'react-intl';

export default defineMessages({
  logout: {
    id: 'User.Header.logout',
    defaultMessage: 'Log out',
  },
  login: {
    id: 'Unknown.Header.login',
    defaultMessage: 'Log in',
  },
});
